/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
/**
 * å¨å±çéç½®æä»¶
 * COMMON_COMFIGï¼ common company config
 */
export const COMMON_COMFIG = {
  // éå®åå°åï¼ ç»åºãåºç°å¼å¸¸ç­
  LOGIN_URL: `/auth/login`,

  /**
   * @desc  é¦é¡µè·¯ç±
   * using:
   * 1) tabåæ¢
   */
  HOME_URL: '/pages/home',

  // æ°æ®è¯·æ±æ¹å¼ -- form
  POST_CONTENT_TYPE_FORM: 'application/x-www-form-urlencoded; charset=UTF-8',

  // æ°æ®è¯·æ±æ¹å¼ -- json
  POST_CONTENT_TYPE_JSON: 'application/json; charset=UTF-8',

  /**
   * è¯·æ±éæ·»å çæå¡å
   */

  // 1ï¼å­ä¸ªæ¨¡å
  ADMIN_SERVER: 'ithinkdt-app-admin',
  // ADMIN_SERVER: "xbom",
  // 2ï¼å­å¸
  DICT_SERVER: 'ithinkdt-app-dict',
  // DICT_SERVER : "xbom",
  // 3) ç»å½ç¸å³
  AUTH_SERVER: 'ithinkdt-app-admin',
  // AUTH_SERVER : "xbom",

  /**
   * ä¸»é¢è²éé¡¹
   */
  DEFAULT_COLORS: [
    {
      key: 'dust',
      color: '#F5222D',
    },
    {
      key: 'volcano',
      color: '#FA541C',
    },
    {
      key: 'sunset',
      color: '#FAAD14',
    },
    {
      key: 'cyan',
      color: '#13C2C2',
    },
    {
      key: 'green',
      color: '#52C41A',
    },
    {
      key: 'daybreak',
      color: '#1890ff',
    },
    {
      key: 'geekblue',
      color: '#2F54EB',
    },
    {
      key: 'purple',
      color: '#722ED1',
    },
  ],

  /**
   * è¡¨åé»è®¤éç½®
   */
  // é»è®¤ç¬¬å é¡µï¼æ¯é¡µæ¾ç¤ºå¤å°
  DEFAULT_TABLE: {
    pageSize: 10,
    pageNumber: 1,
    backPage: true,
  },

  // æä½codeç 
  OPERATE_CODES: {
    add: 'ADD',
    edit: 'EDIT',
    view: 'VIEW',
    delete: 'DEL',
    lock: 'LOCK',
    unlock: 'UNLOCK',
    config: 'CONF',
  },

  // é»è®¤æåºå³é®è¯
  DEFAULT_SORT: {
    sortName: '',
    sortOrder: '',
  },
  // æ·±è¿ªéç½®çæåºæ¹å¼
  SORT_META_ITHINKDT: {
    ascend: 'asc',
    descend: 'desc',
  },
  // ng-zorroç»ä»¶è¿åçæåºæ¹å¼
  SORT_META_NGZORRO: {
    ascend: 'ascend',
    descend: 'descend',
  },
};
